<script setup lang="ts">
import { IconDesign, IconFactoring, IconStore, IconSpeakerOff, IconSolar, IconFactoryToCustomer } from '#components'

const t2 = useT2({
  'Our design': 'Mūsų unikalūs dizainai',
  'Made with solar power': 'Pagaminta naudojant saulės energiją',
  // 'Made by us': 'Pagaminta mūsų',
  // 'Modern factories': 'Šiuolaikinės gamyklos',
  'Modern factories': 'Inovatyvūs gamybos sprendimai',
  // 4.Firminė ir internetinė parduotuvė (angliškai pakeisčiau vietoj „company stores“ į „Brand store“
  'Online and company stores': 'Firminė ir internetinė parduotuvė',
  'From our factory to the customer': 'Produkcija tiesiai iš gamintojo',
  'Small advertising campaigns': 'Nedidelės reklaminės kampanijos',
  // 'Luxury quality, fair price': 'Prabangos kokybė už sąžiningą kainą',
  'Luxury quality, fair price': 'Prabanga ir kokybė gamintojo kaina',
  'More about us': 'Daugiau apie mus',
  'How we do it': 'Kaip mes tai darome',
  description: {
    en: 'No investment in intermediaries or unnecessary costs. Only expert design, premium fabrics, and exceptional manufacturing skills.',
    // lt: 'Jokių investicijų į tarpininkus ar nereikalingas išlaidas. Tik ekspertų dizainas, aukščiausios kokybės audiniai ir išskirtiniai gamybos įgūdžiai.',
    lt: 'Išskirtinio dizaino, aukščiausios kokybės lino tekstilės gaminiai be jokių tarpininkų mokesčių.',
  },
})

const { myLink } = useLinks()
// const fast = useFast()

const icons = computed((): { txt: stringI18n; icon: VueComponent }[] => {
  return [
    { txt: t2('Our design'), icon: IconDesign },
    { txt: t2('Made with solar power'), icon: IconSolar },
    { txt: t2('Modern factories'), icon: IconFactoring },
    { txt: t2('Online and company stores'), icon: IconStore },
    { txt: t2('From our factory to the customer'), icon: IconFactoryToCustomer },
    { txt: t2('Small advertising campaigns'), icon: IconSpeakerOff },
  ]
})

const imgSrc = 'https://media.linenbylinas.com/image/6a1d42d59ded9f85dc92a932/ec5965a6-f1a3-4fba-820e-389c96cee261.png'
const { getFullUrl } = useInternalImageMultiget(() => [imgSrc])
const img = computed(() => getFullUrl(imgSrc))
</script>

<template>
  <div class="_pt140 _pl1 _pr1" :class="$clsClass('banner')" style="min-height: 520px">
    <div :class="$style.innter" class="_glass bg _b5">
      <BaseImage v-if="img" :class="$style.img" lazy sizes="100vw" :img />
      <div :class="$style.icons">
        <div v-for="(item, index) in icons" :key="index" :class="$style.icon">
          <span :class="$style.nr">{{ index + 1 }}.</span>
          <div v-if="item.txt" class="_h3 _fs12 _ls-xs _fw-xl">{{ item.txt }}</div>
          <div :class="$style.icon2"><component :is="item.icon" class="_svg" /></div>
          <!-- <span :class="$style.bottom" /> -->
        </div>
      </div>

      <div :class="$style.txt" class="_col _ctrY">
        <h2 class="_fw-xxxl _ws-m _fs44 _ls-xxxs _lh09 _ff1">{{ t2('Luxury quality, fair price') }}</h2>
        <div class="_label _pb4 _pt4 _fs1">{{ t2('description') }}</div>
        <LinkUi :to="myLink('info-about', {})" :txt="t2('More about us')" arrow big border />
        <!-- <LazyCatalogLookingFor v-if="fast" /> -->
      </div>
    </div>
  </div>
</template>

<style module>
.img {
  composes: global(_absolute);
  composes: global(_inset);
  composes: global(_noselect);
  opacity: 0.3;
  z-index: -2;
  filter: blur(6px) brightness(140%) grayscale(1);
}
.nr {
  composes: global(_mono);
  composes: global(_fw-xxxl);
  composes: global(_fs09);
  composes: global(_ml1);
}

.innter {
  composes: global(_row);
  composes: global(_gap3);
  composes: global(_br22);
  composes: global(_hidden);
  composes: global(_pl04);
  width: 95%;
}

.txt {
  composes: global(_relative);
  composes: global(_wm100p);
  composes: global(_pt1);
  composes: global(_pb1);
  composes: global(_pr2);
  composes: global(_pl2);

  z-index: 1;
  width: 90ch;
}
.icons {
  composes: global(_relative);
  composes: global(_grid);
  composes: global(_gap04);
  composes: global(_pt04);
  composes: global(_pb04);
  grid-template-columns: repeat(1, minmax(0, 66ch));

  z-index: 1;
}
.icon {
  /* composes: global(_hm60); */
  composes: global(_relative);

  composes: global(_b5);
  composes: global(_bg0);
  composes: global(_mb-1);
  composes: global(_row);
  composes: global(_pr02);
  composes: global(_pl04);
  composes: global(_gap2);
  composes: global(_ctrY);

  composes: global(_ws_nowrap);
  /*  */
  composes: global(_br99);
}

.icon2 {
  composes: global(_ctr);
  composes: global(_w50);
  composes: global(_h50);
  composes: global(_a1);
  composes: global(_mla);
  --svg: 26px;
}
</style>
